export default "__VITE_ASSET__C7SxgL29__"